import Vue from 'vue'
import { Capacitor } from '@capacitor/core'
import { BarcodeScanner } from '@capacitor-community/barcode-scanner'
import { Dialog } from '@capacitor/dialog'
import { Camera } from '@capacitor/camera'

import confirmAction from './confirmAction'

const state = Vue.observable({
  showBackground: true
})

export default {
  data () {
    return {
      showBrowserScan: false
    }
  },

  mixins: [confirmAction],

  computed: {
    showBackground () {
      return state.showBackground
    }
  },

  methods: {
    /**
     * @return {Promise<string>}
     */
    async nativeBarcodeScan () {
      if (!Capacitor.isNativePlatform()) {
        throw new Error('notImplementedOnWeb')
      }
      const status = await Camera.checkPermissions()
      if (status.camera !== 'granted') {
        const result = await Camera.requestPermissions({
          permissions: ['camera']
        })
        if (result.camera === 'granted') {
          state.showBackground = false
          return new Promise(resolve => {
            setTimeout(async () => {
              const result = await BarcodeScanner.startScan() // start scanning and wait for a result
              if (result.hasContent) {
                state.showBackground = true
                resolve(result.content)
              }
            }, 400)
          })
        } else if (result.camera === 'denied') {
          const { value } = await Dialog.confirm({
            title: this.$t('mixins.grantCameraAccess.confirmTitle'),
            message: this.$t('mixins.grantCameraAccess.confirmMessage')
          })

          if (value) {
            await BarcodeScanner.openAppSettings()
          }
        }
      } else {
        state.showBackground = false
        return new Promise(resolve => {
          setTimeout(async () => {
            const result = await BarcodeScanner.startScan() // start scanning and wait for a result
            if (result.hasContent) {
              state.showBackground = true
              resolve(result.content)
            }
          }, 400)
        })
      }
    },

    async nativeBarcodeScanStop () {
      if (!Capacitor.isNativePlatform()) {
        throw new Error('notImplementedOnWeb')
      }
      state.showBackground = true
      await BarcodeScanner.stopScan()
    }
  }
}
